module.exports = __webpack_public_path__ + "static/city_icon_114-4219cabfc4992f8d979a291009c5c2fd.png";